<template>
  <section class="red__circle__wrapper" v-show="!isCycleOnProp">

    <div
      class="red__circle"
      @click="roundAnimationable"
      :class="{
        'red__circle--no-click': isCycleOnProp,
        'red__circle--active-intro': activeClassProp || !isCycleOnProp,
        'round__animation': nextPageProp==='/registration' && roundable
      }"
      @mouseover="MX_isZoom(true)"
      @mouseleave="MX_isZoom(false)"
    >
      <router-link :to="nextPageProp" :class="{'fade-in': fadeIn}"><label class="next_btn">Next</label></router-link>
    </div>

  </section>
</template>

<script>
import { isZooming } from '../mixins/isZooming'

export default {
  name: 'VNextPage',
  props: {
    nextPageProp: {
      type: String,
      required: true
    },
    isCycleOnProp: {
      type: Boolean,
      default: false
    },
    activeClassProp: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    isZooming
  ],
  data () {
    return {
      roundable: false,
      fadeIn: false
    }
  },
  methods: {
    roundAnimationable () {
      this.roundable = true
      // console.log(this.roundable, this.nextPageProp)
      this.$router.go(1)
    }
  },
  mounted () {
    setTimeout(() => {
      this.fadeIn = true
    }, 5000)
  }
}
</script>
